import { render, staticRenderFns } from "./newAlertModal.vue?vue&type=template&id=2e4c78e3&scoped=true"
import script from "./newAlertModal.vue?vue&type=script&lang=js"
export * from "./newAlertModal.vue?vue&type=script&lang=js"
import style0 from "./newAlertModal.vue?vue&type=style&index=0&id=2e4c78e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e4c78e3",
  null
  
)

export default component.exports